import EnvironmentConfig from '../interfaces/EnvironmentConfig';

const saravanaConfig: EnvironmentConfig = {
    dashboardUrl: 'https://crm.supersaravanastores.com',
    ruleServerUrl: 'https://classic.api.crm.supersaravanastores.com',
    apiServerUrl: 'https://api.crm.supersaravanastores.com',
    casaWebAppUrl: 'https://web.crm.supersaravanastores.com',
    casaEcomUrl: '',
    casaBeatUrl: '',
    turnedOffFeatures: [],
    keycloakConfig: {
        url: `https://auth.crm.supersaravanastores.com/auth`,
        realm: `casa`,
        clientId: `casa_dashboard`,
    },
    ruleUiUrl: 'https://rule.crm.supersaravanastores.com',
};

export default saravanaConfig;
